import { Global } from '@emotion/react'
import { ThemeProvider } from 'emotion-theming'
import React from 'react'
import { ToastContainer } from 'react-toastify'
import Loading from './components/Loading'
import { globalCSS } from './constants/CSS'
import Routes from './Routes'
import { useThemeValue } from './store/themeState'
import 'react-toastify/dist/ReactToastify.css'
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import useFetchContent from './hooks/api/useFetchContent'
import { useSetContentState } from './store/contentState'


const App: React.FC = () => {
  const theme = useThemeValue()

  const res = useFetchContent() // 获取内容数据
  
  const setContentState = useSetContentState()

  if(res.data){
    setTimeout(() => {
      setContentState(res.data?.data||[])
    })
  }

  return (
    <ThemeProvider theme={theme}>
      <Global styles={globalCSS} />

      <Routes />

      <Loading />

      <ToastContainer position='top-center' autoClose={4000} hideProgressBar style={{
        padding: 40
      }} css={css`
        .Toastify__toast {
          border-radius: 50px;
          padding: 12px;
          min-height: 40px;
        }
      `} />
    </ThemeProvider>
  )
}

export default App
